import { SearchType } from '@aibees/elephant/types';
import { HttpMethod } from '@aibees/shared/definition';
import { useBaseQuery } from '@aibees/shared/http';
import { useWorkspace } from '@aibees/shared/workspace';
import { useMemo } from 'react';
import { PEOPLE_SEARCH_API_METADATA_PREFIX } from '../../constants';
import { CompanySearchBody } from '../../feature/search-table-company/hooks/types';
import { transform as peopleRequestTransform } from '../../feature/search-table-people/hooks/use-browse-people-search';
import { SearchList } from '../search-list/types';
import { useSearchTypeFromRoute } from '@aibees/elephant/hooks';

export function useCreateCompanyIdsSearchListBasedOnPeopleIds({
  searchListId,
  enabled,
}: {
  searchListId?: string;
  enabled: boolean;
}) {
  const workspace = useWorkspace()?.id;

  const type = useSearchTypeFromRoute();

  const transformedRequestParams = useMemo(() => {
    return peopleRequestTransform({
      people_search_list_id: searchListId,
    });
  }, [searchListId]);

  return useBaseQuery<CompanySearchBody, SearchList>(
    [
      useCreateCompanyIdsSearchListBasedOnPeopleIds.name,
      {
        ...transformedRequestParams,
      },
    ],
    {
      url: PEOPLE_SEARCH_API_METADATA_PREFIX.replace(':wid', String(workspace)),
      method: HttpMethod.post,
      params: { return: 'company_id_search_list' },
      data: {
        ...transformedRequestParams,
        ...{
          size: 10000, // this is the size limit for any search query
          page: 0, // it should be always zero
        },
      },
    },
    {
      enabled: type === SearchType.People && !!searchListId && enabled,
    }
  );
}
